
import { FuelUser } from "../models/user";
import { fuelPortalAxios } from "./interceptor";

const FuelUserManagementService = {
    // log: new Log(),

    async upsert(payload: FuelUser, ouId: string): Promise<FuelUser> {

        const buildUrl = () => {
            const path = `auth/user/${ouId}`;
            return path;
        };

        const url = buildUrl();
        try {
            const res = await fuelPortalAxios.post(url, payload);
            return res.data;
        } catch (err) {
            throw new Error();
        }
    },

    async deleteUser(ouId: string,id: string): Promise<any> {
        const buildUrl = () => {
            const path = `auth/user/${ouId}/${id}`;
            return path;
        };

        const url = buildUrl();
        try {
            const res = await fuelPortalAxios.delete(url);
            return res;
        } catch (err) {
            throw new Error();
        }
    },
    
    async getUser(id: string): Promise<FuelUser> {
        const url = `auth/user/${id}`;
        try {
            const res = await fuelPortalAxios.get(url);
            return res.data;
        } catch (err) {
            throw new Error();
        }
    },
    async sendPasswordResetEmail(userId: string): Promise<number> {
        const url = `auth/user/${userId}/passwordreset`;
        try {
            const res = await fuelPortalAxios.post(url);
            return res.status;
        } catch (err) {
            throw new Error();
        }
    },
    
    async getUsersByOuId(ouId: string, listParentOuUsers:boolean = false): Promise<FuelUser[]> {
        const url = `auth/users/${ouId}?listParentOuUsers=${listParentOuUsers}`;
        try {
            const res = await fuelPortalAxios.get(url);
            return res.data;
        } catch (err) {
            throw new Error();
        }
    },
    async getAllRoles(): Promise<string[]> {
        const url = `auth/roles`;
        try {
            const res = await fuelPortalAxios.get(url);
            return res.data;
        } catch (err) {
            throw new Error();
        }
    }


}

export { FuelUserManagementService }